module.exports = ".scroll-container {\n    max-height: 150px;\n    overflow-y: hidden;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.gradient {\n    position: absolute;\n    bottom: 0;\n    height: 50px;\n    width: 100%;\n    background: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0.3)), to(rgba(255, 255, 255, 1)));\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 1));\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/expandable-panel/expandable-panel.component.css
// module id = ./src/app/shared/components/expandable-panel/expandable-panel.component.css
// module chunks = main